<template>
  <v-row>
    <template>

      <fin-video-dialog v-model="showVideoDialog"
                        :src="videoUrl"
                        @input="val => showVideoDialog = val">
        <div class="video-container" style="display: inline-block; vertical-align: top; width: 100%;">
          <fin-video-secure v-if="videoUrl"
                            :isApp="isApp">
            <prismic-embed :field="videoUrl"></prismic-embed>
          </fin-video-secure>
        </div>
      </fin-video-dialog>

      <v-col v-if="tags.length > 1" cols="12">
        <fin-dropdown :items="tags"
                      :value="selectedTags"
                      label="Kategorie"
                      show-selection
                      @input="val => tagSelectionChanged(val)"/>
        <div v-if="selectedTags.length > 0"
             :style="'min-height: 32px;' + disabled ? 'opacity: 0.4;' : ''"
             class="mb-3">
          <span class="mr-2" style="font-weight: bold;">Aktive Filter: </span>

          <span>
            <fin-tag v-for="filter in selectedTags"
                     :key="filter.id" class="mr-2"
                     style="display: inline-block;">
              {{ filter.title }}
              <v-btn icon
                     x-small
                     @click="removeFilter(filter.id)">
                <v-icon>icon-close-small</v-icon>
              </v-btn>
            </fin-tag>
          </span>
        </div>
      </v-col>
      <v-col v-for="(post, index) in filteredPosts" :key="index" align-self="baseline" cols="6" lg="3" md="4" xl="3">
        <fin-post-card :key="post.id"
                       :post="post"
                       class="py-6"
                       @click="openEntry(post)"/>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import FinVideoDialog from "@/components/common/video/VideoDialog"
import FinPostCard from "@/components/pages/finAcademy/grid/PostCard"
import FinDropdown from "@/components/common/Dropdown"
import finBrowser from "@/js/finBrowser"
import {mapGetters} from "vuex"
import {EventBus} from "@/plugins/fincraft"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"

export default {
  name: "FinAcademyGrid",
  components: {FinDropdown, FinPostCard, FinVideoDialog},
  props: {
    posts: {
      required: true
    }
  },
  data() {
    return {
      showVideoDialog: false,
      videoUrl: undefined,
      selectedTags: [],
      priceModelOrder: ['basic', 'extended', 'advanced']
    }
  },
  methods: {
    openEntry(post) {
      const availableFromPriceModel = this.priceModelOrder.find(pmo => post[pmo] === true)
      const entryEnabled = this.groupPriceModel && (this.groupPriceModel.id === 'DEVELOPER' || this.groupPriceModel.id === 'TRIAL' || post[this.groupPriceModel.id.toLowerCase()] === true)
      if (!entryEnabled) {
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.ACADEMY.id, PRICEMODEL_FEATURE_RESTRICTIONS.QUALITY, {visibleFrom: availableFromPriceModel.toUpperCase()})
      } else {
        if (post.video.embed_url) {
          this.showVideoDialog = true
          this.videoUrl = post.video
        } else {
          this.videoUrl = undefined
          const goTo = {
            name: 'academyEntry',
            params: {
              entryId: post.id,
            }
          }
          this.$router.push(goTo)
        }
      }
    },
    tagSelectionChanged(val) {
      this.selectedTags = val
    },
    removeFilter(id) {
      if (id) {
        this.selectedTags = this.selectedTags.filter(c => c.id !== id)
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['userId', 'groupPriceModel']),
    filteredPosts() {
      if (this.selectedTags.length === 0) {
        return this.posts
      } else {
        return this.posts.filter(post => post._meta.tags.some(tag => this.selectedTags.find(selTag => selTag.title === tag)))
      }
    },
    tags() {
      const res = new Set([])
      this.posts.forEach(post => {
        post._meta.tags.forEach(tag => {
          res.add(tag)
        })
      })
      const result = [...res].map((entry) => ({
        id: entry,
        title: entry
      }))
      return [...result]
    },
    isApp() {
      return finBrowser.IS_IOS_OR_ANDROID_APP
    }
  }
}
</script>

<style lang="scss" scoped>

.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 0;
  height: 0;
  overflow: hidden;
}

.video-container ::v-deep iframe,
.video-container ::v-deep object,
.video-container ::v-deep embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%
}
</style>
